import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageViewHeaderWithActionBar from '@/components/common/Header/PageViewHeaderWithActionBar.vue'
import ApprovalStateContainer from '@workflow/containers/ApprovalStateContainer.vue'
@Component({
    components: { PageViewHeaderWithActionBar, ApprovalStateContainer }
})
export default class ApprovalStateView extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    searchMode: boolean = false
}
